export const purchaseStatus = [{
  value: 'Undefined', label: 'Undefined', color: 'gray'
}, {
  value: 'Paid', label: 'Paid', color: 'green'
}, {
  value: 'Refunded', label: 'Refunded', color: 'orange'
}, {
  value: 'PartialRefunded', label: 'Partial Refunded', color: 'yellow'
}];